/**
 * MATAFOME — API DO PAINEL MASTER SAAS ADMINISTRATIVO
 */

import { safeApiFetch, getAuthHeaders, getCurrentStore, currentToken } from './core.api';

export async function masterAuth(masterKey) {
    const res = await safeApiFetch('/api/master/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: masterKey })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Chave Mestra incorreta.');
    return data;
}

export async function fetchMasterStores(masterKey) {
    const res = await safeApiFetch('/api/master/stores', {
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar lista de lojas.');
    return data;
}

export async function createMasterStore(storeData, masterKey) {
    const res = await safeApiFetch('/api/master/stores', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify(storeData)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao cadastrar restaurante.');
    return data;
}

export async function updateMasterStore(storeId, updates, masterKey) {
    const res = await safeApiFetch(`/api/master/stores/${storeId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify(updates)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao atualizar dados da loja.');
    return data;
}

export async function deleteMasterStore(storeId, masterKey) {
    const res = await safeApiFetch(`/api/master/stores/${storeId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao excluir loja.');
    return data;
}

// ==========================================
// FUNIL DO AGENTE DE IA
// ==========================================

export async function fetchAiFunnel(storeId = null) {
    const store = getCurrentStore();
    const effectiveStoreId = storeId || store?.id || '';
    const query = effectiveStoreId ? `?storeId=${encodeURIComponent(effectiveStoreId)}` : '';
    const res = await safeApiFetch(`/api/ai/funnel${query}`, {
        headers: getAuthHeaders()
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar o funil da IA.');
    return data.funnel;
}

export async function updateAiFunnel(funnelData, storeId = null) {
    const store = getCurrentStore();
    const effectiveStoreId = storeId || store?.id || '';
    const query = effectiveStoreId ? `?storeId=${encodeURIComponent(effectiveStoreId)}` : '';
    const res = await safeApiFetch(`/api/ai/funnel${query}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(funnelData)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao salvar o funil da IA.');
    return data;
}

export async function resetSimulatorSession(customerPhone = '5511999990000', storeId = null) {
    const store = getCurrentStore();
    const effectiveStoreId = storeId || store?.id || '';
    const query = effectiveStoreId ? `?storeId=${encodeURIComponent(effectiveStoreId)}` : '';
    const res = await safeApiFetch(`/api/ai/reset-session${query}`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ customerPhone })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao resetar sessão do simulador.');
    return data;
}

// ==========================================
// CONFIGURAÇÕES GLOBAIS DE IA (MASTER SAAS)
// ==========================================

export async function fetchMasterAiSettings(masterKey) {
    const res = await safeApiFetch('/api/master/ai-settings', {
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar configurações de IA.');
    return data.settings;
}

export async function saveMasterAiSettings(settings, masterKey) {
    const res = await safeApiFetch('/api/master/ai-settings', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify(settings)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao salvar configurações de IA.');
    return data;
}

export async function testMasterAiConnection(provider, apiKey, masterKey) {
    const res = await safeApiFetch('/api/master/ai-test', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify({ provider, apiKey })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao testar conexão.');
    return data;
}

// ==========================================
// CONFIGURAÇÕES MERCADO PAGO SAAS (MASTER)
// ==========================================

export async function fetchMasterMpSettings(masterKey) {
    const res = await safeApiFetch('/api/master/mercadopago', {
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar configurações do Mercado Pago.');
    return data;
}

export async function saveMasterMpSettings(settings, masterKey) {
    const res = await safeApiFetch('/api/master/mercadopago', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify(settings)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao salvar credenciais do Mercado Pago.');
    return data;
}

export async function testMasterMpSettings(payload, masterKey) {
    const res = await safeApiFetch('/api/master/mercadopago/test', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-master-key': masterKey
        },
        body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao testar Mercado Pago.');
    return data;
}

// ==========================================
// CONFIGURAÇÕES DE SUPORTE SAAS (MASTER & PÚBLICO)
// ==========================================

export async function getMasterSupport(masterKey) {
    const headers = { 'Content-Type': 'application/json' };
    if (masterKey) {
        headers['x-master-key'] = masterKey;
    } else if (currentToken) {
        headers['Authorization'] = `Bearer ${currentToken}`;
    }
    const res = await safeApiFetch('/api/master/support', { headers });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar canais de suporte.');
    return data;
}

export async function saveMasterSupport(settings, masterKey) {
    const headers = { 'Content-Type': 'application/json' };
    if (masterKey) {
        headers['x-master-key'] = masterKey;
    } else if (currentToken) {
        headers['Authorization'] = `Bearer ${currentToken}`;
    }
    const res = await safeApiFetch('/api/master/support', {
        method: 'POST',
        headers,
        body: JSON.stringify(settings)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao salvar canais de suporte.');
    return data;
}

export async function fetchPublicSupport() {
    const res = await safeApiFetch('/api/public/support');
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao carregar suporte do SaaS.');
    return data;
}


// ==========================================
// IMPORTAÇÃO DE CARDÁPIO COM IA (FOTO OU PDF)
// ==========================================
